import React, { Component } from 'react'
import ContactContainer from './container'
import ProductObj from '../../utils/producto'
import ContactObj from '../../utils/contacto'
const con = new ContactObj()
const prod = new ProductObj()

export default class Contact extends Component {
  constructor() {
    super()
    this.state = {
      contact: con,
      productId: '',
      error: null,
      products: []
    }
    this.onChange = this.onChange.bind(this)
    this.onChangeProduct = this.onChangeProduct.bind(this)
    this.enviarMensaje = this.enviarMensaje.bind(this)
  }

  onChange(e) {
    this.setState({
      contact: {
        ...this.state.contact,
        [e.target.id]: e.target.value
      }
    })
  }

  onChangeProduct(e) {
    this.setState({
      contact: {
        ...this.state.contact,
        Producto: e.target.value
      },
      productId: e.target.value
    })
  }

  enviarMensaje(e) {
    e.preventDefault()
    const _this = this
    _this.setState({
      error: null
    })
    con.enviarCorreo(this.state.contact).then(() => {
      _this.setState({
        contact: new ContactObj(),
        error: null
      })
      document.forms[0].reset()
    })
      .catch(err => _this.setState({ error: err }))
  }

  leerProductos() {
    const _this = this
    prod.leerProductos().then(products => _this.setState({ products }))
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    const productId = this.props.match.params.productId
    if (this.props.match) {
      this.setState({
        productId,
        contact: {
          ...this.state.contact,
          Producto: productId
        }
      })
    }
  }

  componentWillMount() {
    this.leerProductos()
  }

  render() {
    return (
      <ContactContainer
        contact={this.state.contact}
        onChangeProduct={this.onChangeProduct}
        productId={this.state.productId}
        products={this.state.products}
        onChange={this.onChange}
        enviarMensaje={this.enviarMensaje}
        error={this.state.error}
      />
    )
  }
}